import { computed } from "vue";
import { useSiteTemplate } from "@/composables/useSiteTemplate";

function normalizeTemplateClassToken(value = "") {
  const normalizedValue = String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_-]+/g, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "");

  return normalizedValue || "default";
}

export function useTemplateTheme() {
  const { siteTemplate, templateKey } = useSiteTemplate();

  const normalizedTemplateKey = computed(() => {
    return normalizeTemplateClassToken(templateKey.value || "default");
  });

  const normalizedTemplateStyle = computed(() => {
    return normalizeTemplateClassToken(
      siteTemplate.value?.styleInfo?.normalized || templateKey.value || "default"
    );
  });

  const templateClassList = computed(() => {
    return [
      "site-template-root",
      `site-template--${normalizedTemplateKey.value}`,
      `site-template-style--${normalizedTemplateStyle.value}`,
    ];
  });

  const templateAttrMap = computed(() => {
    return {
      "data-template-key": normalizedTemplateKey.value,
      "data-template-style": normalizedTemplateStyle.value,
    };
  });

  return {
    normalizedTemplateKey,
    normalizedTemplateStyle,
    templateClassList,
    templateAttrMap,
  };
}

export default useTemplateTheme;
